/* @flow */

export const replace = (values: string[], i18nString: string) =>
  values.reduce((pre, cur) => pre.replace('##', cur), i18nString)
export const getLabel = (label: string, i18n: Object = {}, fallbackStr?: string): string =>
  i18n[label] || (fallbackStr || label)
